<template>
  <v-text-field
    ref="mastercal_nf"
    v-model="model"
    v-bind="computedProps"
    :rules="buildRules()"
    v-on="$listeners"
    @blur="format"
    class="align-right"
    :append-icon="enableicons ? 'add' : ''"
    :prepend-inner-icon="enableicons ? 'remove' : ''"
    @click:append="enableicons ? addfunc(row, fieldname, range) : testfunc()"
    @click:prepend-inner="enableicons ? subfunc(row, fieldname, range) : testfunc()"
    >
  </v-text-field>
</template>

<script>
    import { VTextField } from 'vuetify/lib';
    import {f_rules} from '../../utils/commonUtils'
    import Big from 'big.js'
    
    export default {
         name: 'NumericField',
        extends: VTextField,

        props: {
            precision: {
                type: Number,
                default: -1
            },
            negative: {
                type: Boolean,
                default: false
            },
            max: {
                type: String,
                default: null
            },
            min: {
                type: String,
                default: null
            },
            addfunc: {
                type: Function,
                required: false,
                default: null
            },
            subfunc: {
                type: Function,
                required: false,
                default: null
            },
            enableicons: {
                type: Boolean,
                required: false,
                default: false
            },
            row: {
                type: Object,
                required: false,
                default: null
            },
            fieldname: {
                type: String,
                required: false,
                default: null
            },
            range: {
                type: Object,
                required: false,
                default: null
            }
        },
        data() {
            return {
                numericStr: this.value,
                model: null,
                changedInput: false
            }
        },
        created() {
            this.$listeners['input'] = this.checkFormat
        },
        mounted() {
            if(this.numericStr==undefined || this.numericStr==null || this.numericStr===''){
                return
            }
            this.numericStr = this.numericStr.toString()
            this.model = this.numericStr.replace('.', ',')
            this.format()
            this.emitValue()
            //this.$emit('input', this.numericStr)
        },
        watch: {
            value: function(newVal, oldVal) {
                console.log('NUMERIC', newVal, oldVal)
                if (!this.changedInput) {
                    if (oldVal == undefined || oldVal == null) {
                        oldVal = ''
                    }
                    if (newVal==undefined || newVal == null) {
                        this.numericStr = ''
                        this.model = ''
                        this.emitValue()
                        //this.$emit('input', this.numericStr)
                    } else if(newVal.toString()!=oldVal.toString()) {
                        this.numericStr = newVal.toString()
                        this.format()
//                        this.emitValue()
                        //this.$emit('input', this.numericStr)
                    }
                }
            },
            precision: function() {
                this.changedInput = false
                this.format()
//                this.emitValue()
                //this.$emit('input', this.numericStr)
            },
        
        },
        methods: {
            testfunc(){
                console.log("$$click")
            }, 
            emitValue() {
                
                //this.model = this.model.replace('.', ",")
                if (this.$refs.mastercal_nf.validate()) {
                    if (this.numericStr != this.value) {
                        this.$emit('input', this.numericStr)
                    }
                }
            },
            format() {
                //this.$refs.mastercal_nf.validate()
                if (!this.numericStr || !this.$refs.mastercal_nf.validate()){
                    return
                }
                let n = new Big(this.numericStr)
                if (this.precision != -1) {
                    this.numericStr = n.toFixed(this.precision).toString()
                }
                this.model = this.numericStr.replace('.',',');
                this.$refs.mastercal_nf.lazyValue = this.model
                this.emitValue()
            },
            checkFormat(val) {
                this.changedInput = true
                this.model = val
                if (!this.model) {
                    this.numericStr = null
                } else {
                    // check precision
                    this.numericStr = this.model.replace(',', '.')
                    let groups = this.model.split(",")
                    if (groups[1]) {
                        let digits = groups[1].length || 0;
                        if (this.precision != -1 && digits > this.precision) {
                            this.format()
                        }
                    }
                }
                this.emitValue()
                //this.$emit('input', this.numericStr)
                this.$nextTick(function(){
                    this.changedInput = false
                })
            },
            minValRules(){
                return f_rules.minRules(this.numericStr, this.min)
            },
            maxValRules(){
                return f_rules.maxRules(this.numericStr, this.max)
            },
            buildRules() {
                let rules = [this.negative ? f_rules.negativeNumberRules : f_rules.numberRules]
                
                if (this.min) {
                    rules.push(this.minValRules)
                }
                if (this.max) {
                    rules.push(this.maxValRules)
                }
                return [...this.$props.rules, ...rules]
            }
        },
        computed: {
            computedProps() {
                return {
                    value: this.numericStr,
                    ...this.$props,
                }
            }
        }
    }
</script>
<style lang="scss">
    .align-right .v-text-field__slot input {
        text-align: right;
        padding-right: 4px;
    }
    .align-left .v-text-field__slot input {
        text-align: left;
    }
    .align-center .v-text-field__slot input {
        text-align: center;
    }
</style>